import rtAvatar from './rtAvatar'

export default rtAvatar



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/avatar/index.js